import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { useSelector } from 'react-redux';

export const Emoji = ({ ...props }) => {
    const currentLanguage = useSelector((state) => state.translation.language) || 'en';

    const emojiLocaleMap = {
        'zh-cn': 'zh',
        'zh_cn': 'zh',
        // add more if needed
    };

    const locale = emojiLocaleMap[currentLanguage] || currentLanguage;
    
    return <Picker locale={locale} data={data}  previewPosition="none" theme="light" skinTonePosition="none" {...props} />
}